import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getHeaders } from "./getHeaders";

// ============================

export const getOrdersDrivers = createAsyncThunk(
  "Drivers/getOrdersDrivers",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/admin/drivers`,
        {
          headers: getHeaders(),

          params: {
            admin_in_zones: 1,
            HasContract: 1,
            ...data,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getDrivers = createAsyncThunk(
  "Drivers/getDrivers",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/admin/drivers`,
        {
          headers: getHeaders(),

          params: {
            admin_in_zones: 1,
            payment:1,
            ...data,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const addDrivers = createAsyncThunk(
  "Drivers/addDrivers",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(`${process.env.REACT_APP_BACKEND_API}api/admin/drivers`, data, {
          headers: getHeaders(true),
        })
        .then((res) => res.data);

      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const EditDriversDispatch = createAsyncThunk(
  "Drivers/EditDriversDispatch",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/admin/drivers/${data.id}/update`,
          data,
          {
            headers: getHeaders(true),
          }
        )
        .then((res) => res.data);

      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const delDrivers = createAsyncThunk(
  "Drivers/delDrivers",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BACKEND_API}api/admin/drivers${
          !Array.isArray(id) ? `/${id}` : ""
        }`,
        {
          headers: getHeaders(),
          ...(Array.isArray(id) && { data: { ids: id } }), // إرسال `id` كمصفوفة داخل `data`
        }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getDriversId = createAsyncThunk(
  "Drivers/getDriversId",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/admin/drivers/${id}`, {
          headers: getHeaders(),
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

// ============================

// ============================
export const getPlan = createAsyncThunk(
  "Drivers/getPlan",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/admin/plans`,
        {
          headers: getHeaders(),

          params: data && data,
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const addPlan = createAsyncThunk(
  "Drivers/addPlan",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(`${process.env.REACT_APP_BACKEND_API}api/admin/plans`, data, {
          headers: getHeaders(true),
        })
        .then((res) => res.data);

      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const EditPlan = createAsyncThunk(
  "Drivers/EditPlan",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/admin/plans/${data.id}/update`,
          data,
          {
            headers: getHeaders(),
          }
        )
        .then((res) => res.data);

      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const delPlan = createAsyncThunk(
  "Drivers/delPlan",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BACKEND_API}api/admin/plans/${id}`,
        {
          headers: getHeaders(),
        }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getPlanId = createAsyncThunk(
  "Drivers/getPlanId",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/admin/plans/${id}`, {
          headers: getHeaders(),
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

// ============================
export const getVehicleTypes = createAsyncThunk(
  "Drivers/getVehicleTypes",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/driver/vehicle_types`,
        {
          headers: getHeaders(),
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getEducationalLevels = createAsyncThunk(
  "Drivers/getEducationalLevels",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/driver/educational_levels`,
        {
          headers: getHeaders(),
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getDriversLocations = createAsyncThunk(
  "Drivers/getDriversLocations",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/admin/statistics/drivers-locations`,
        {
          headers: getHeaders(),
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
const DriversSlice = createSlice({
  name: "Drivers",
  initialState: {
    isDriversLoading: false,
    error: null,
    UsersArr: null,
    getDriversArray: null,
    OrdersDriversArray: null,
    DriversIDArray: null,
    getPlanArray: null,
    PlanIDArray: null,
    VehicleTypesArray: null,
    EducationalLevelsArray: null,
    DriversLocationsArray: null,
  },

  extraReducers: {
    [getVehicleTypes.pending]: (state, action) => {
      state.isDriversLoading = true;
    },
    [getVehicleTypes.fulfilled]: (state, action) => {
      state.VehicleTypesArray = action.payload.data;
      state.isDriversLoading = false;
    },
    [getVehicleTypes.rejected]: (state, action) => {
      state.isDriversLoading = false;
    },

    [getEducationalLevels.pending]: (state, action) => {
      state.isDriversLoading = true;
    },
    [getEducationalLevels.fulfilled]: (state, action) => {
      state.EducationalLevelsArray = action.payload.data;
      state.isDriversLoading = false;
    },
    [getEducationalLevels.rejected]: (state, action) => {
      state.isDriversLoading = false;
    },

    [getDriversId.pending]: (state, action) => {
      state.isDriversLoading = true;
    },
    [getDriversId.fulfilled]: (state, action) => {
      state.DriversIDArray = action.payload.data;
      state.isDriversLoading = false;
    },
    [getDriversId.rejected]: (state, action) => {
      state.isDriversLoading = false;
    },
    [getDrivers.pending]: (state, action) => {
      state.isDriversLoading = true;
    },
    [getDrivers.fulfilled]: (state, action) => {
      state.getDriversArray = action.payload.data;
      state.isDriversLoading = false;
    },

    [getDrivers.rejected]: (state, action) => {
      state.isDriversLoading = false;
    },

    // getOrdersDrivers
    [getOrdersDrivers.pending]: (state, action) => {
      state.isDriversLoading = true;
    },
    [getOrdersDrivers.fulfilled]: (state, action) => {
      state.OrdersDriversArray = action.payload.data;
      state.isDriversLoading = false;
    },

    [getOrdersDrivers.rejected]: (state, action) => {
      state.isDriversLoading = false;
    },

    [addDrivers.pending]: (state, action) => {
      state.isDriversLoading = true;
    },
    [addDrivers.fulfilled]: (state, action) => {
      state.isDriversLoading = false;
    },
    [addDrivers.rejected]: (state, action) => {
      state.isDriversLoading = false;
    },
    [EditDriversDispatch.pending]: (state, action) => {
      state.isDriversLoading = true;
    },
    [EditDriversDispatch.fulfilled]: (state, action) => {
      state.isDriversLoading = false;
    },
    [EditDriversDispatch.rejected]: (state, action) => {
      state.isDriversLoading = false;
    },
    [delDrivers.pending]: (state, action) => {
      state.isDriversLoading = true;
    },
    [delDrivers.fulfilled]: (state, action) => {
      state.isDriversLoading = false;
      const idsToDelete = Array.isArray(action.meta.arg)
        ? action.meta.arg
        : [action.meta.arg];

      state.getDriversArray = state.getDriversArray.filter(
        (ele) => !idsToDelete.includes(ele.id)
      );
    },
    [delDrivers.rejected]: (state, action) => {
      state.isDriversLoading = false;
    },
    [getPlan.pending]: (state, action) => {
      state.isDriversLoading = true;
    },
    [getPlan.fulfilled]: (state, action) => {
      state.getPlanArray = action.payload.data;
      state.isDriversLoading = false;
    },
    [getPlan.rejected]: (state, action) => {
      state.isDriversLoading = false;
    },
    [addPlan.pending]: (state, action) => {
      state.isDriversLoading = true;
    },
    [addPlan.fulfilled]: (state, action) => {
      state.isDriversLoading = false;
    },
    [addPlan.rejected]: (state, action) => {
      state.isDriversLoading = false;
    },

    [delPlan.pending]: (state, action) => {
      state.isDriversLoading = true;
    },
    [delPlan.fulfilled]: (state, action) => {
      state.isDriversLoading = false;
    },
    [delPlan.rejected]: (state, action) => {
      state.isDriversLoading = false;
    },

    [EditPlan.pending]: (state, action) => {
      state.isDriversLoading = true;
    },
    [EditPlan.fulfilled]: (state, action) => {
      state.isDriversLoading = false;
    },
    [EditPlan.rejected]: (state, action) => {
      state.isDriversLoading = false;
    },

    [getPlanId.pending]: (state, action) => {
      state.isDriversLoading = true;
    },
    [getPlanId.fulfilled]: (state, action) => {
      state.PlanIDArray = action.payload.data;
      state.isDriversLoading = false;
    },
    [getPlanId.rejected]: (state, action) => {
      state.isDriversLoading = false;
    },

    [getDriversLocations.pending]: (state, action) => {
      state.isDriversLoading = true;
    },
    [getDriversLocations.fulfilled]: (state, action) => {
      state.DriversLocationsArray = action.payload.data;
      state.isDriversLoading = false;
    },
    [getDriversLocations.rejected]: (state, action) => {
      state.isDriversLoading = false;
    },
  },
});

export default DriversSlice.reducer;
